<template>
  <InSharesContext
    v-if="selectedOrganizationId"
    :organization-id="selectedOrganizationId"
  >
    <RouterView></RouterView>
  </InSharesContext>
</template>

<script setup lang="ts">
import { useAccountMembershipsContext } from '@/composables/deepadmin/use-account-memberships-context.ts'
import InSharesContext from '@/components/deepbox/in-shares/InSharesContext.vue'

definePage({
  meta: {
    breadcrumbLabelKey: 'navigation.deepbox.in_shares',
  },
})

const { selectedOrganizationId } = useAccountMembershipsContext()
</script>
